const maxLength = 16

export const summary = {
  pathname: ({ ids }) => {
    const slicedIds = ids.slice(0, maxLength)
    return `/api/v4/search/summary/${slicedIds.join(',')}`
  },
  search: ({ search }) => search,
  headers: {
    'Kapi-Enabled-Version': 'Next',
    'X-Kapi-Llm-Prev': 'ef43752661356157c9a827dcc206225ee9450740c09f3a219f30d1d91258d1c6'
  }
}

export const summaryFeedback = {
  pathname: ({ ids }) => {
    const slicedIds = ids.slice(0, maxLength)
    return `/api/v4/search/summary/${slicedIds.join(',')}/feedback`
  },
  method: 'POST',
  headers: {
    'Kapi-Enabled-Version': 'Next',
    'X-Kapi-Llm-Prev': 'ef43752661356157c9a827dcc206225ee9450740c09f3a219f30d1d91258d1c6',
    'content-type': 'application/json'
  },
  body: ({ feedback }) => feedback
}
